import { render, staticRenderFns } from "./LegalDocumentCertificationDetails.vue?vue&type=template&id=581133d7&scoped=true&"
import script from "./LegalDocumentCertificationDetails.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentCertificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentCertificationDetails.vue?vue&type=style&index=0&id=581133d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581133d7",
  null
  
)

export default component.exports